export default __webpack_public_path__ + "dist/media/Medal.9a896559.svg";